"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _excluded = ["unique"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var propTypes = {
  unique: _propTypes.string
};

var Mac = function Mac(_ref) {
  var _ref$unique = _ref.unique,
      unique = _ref$unique === void 0 ? "" : _ref$unique,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("defs", {
    fill: "inherit"
  }), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "inherit",
    fillRule: "evenodd",
    id: "glyphs/alert/mac-mac" + unique,
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/_react["default"].createElement("use", {
    fill: "inherit",
    id: "combined-shape-mac" + unique,
    xlinkHref: "#path-1-mac" + unique
  }), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "inherit",
    id: "colors/core/gunmetal-mac" + unique
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M20,17.607 C19.214,19.887 16.861,23.924 14.437,23.968 C12.829,23.999 12.312,23.015 10.474,23.015 C8.637,23.015 8.062,23.938 6.542,23.998 C3.97,24.097 0,18.171 0,13.003 C0,8.256 3.308,5.903 6.198,5.86 C7.748,5.832 9.212,6.905 10.157,6.905 C11.106,6.905 12.884,5.615 14.753,5.804 C15.535,5.837 17.732,6.119 19.142,8.181 C15.401,10.623 15.984,15.73 20,17.607 Z M14.778,0 C11.952,0.114 9.646,3.079 9.968,5.531 C12.58,5.734 15.086,2.806 14.778,0 Z",
    id: "path-1-mac" + unique
  }))));
};

Mac.propTypes = propTypes;
var _default = Mac;
exports["default"] = _default;